import { Switch } from '@components/Switch';
import { GatedLabel } from './GatedLabel';

export const GatedSwitch = ({
    gated = false,
    onUpgradeClick,
    label = '',
    checked,
    handleChange,
    className,
    style,
    sx,
    disabled = false,
}) => {
    if (!gated) {
        return (
            <Switch
                checked={checked}
                handleChange={handleChange}
                label={label}
                className={className}
                style={style}
                sx={sx}
                disabled={disabled}
            />
        );
    }

    const onAttemptedChange = () => {
        if (typeof onUpgradeClick === 'function') {
            onUpgradeClick();
        }
    };

    return (
        <Switch
            checked={false}
            handleChange={disabled ? () => {} : onAttemptedChange}
            label={<GatedLabel>{label}</GatedLabel>}
            className={className}
            style={style}
            sx={sx}
            disabled={disabled}
        />
    );
};

export default GatedSwitch;
